import { type FC } from "react";
import { Autocomplete, TextField } from "@mui/material";

// Значения нормализуются на бэкенде (backend/src/utils/normalizeDeviceType.ts)
// из сырых UA-строк — фиксированный набор, отдельного справочника/enum в
// GraphQL-схеме под них нет.
const DEVICE_TYPES = ["Mobile", "Tablet", "TV", "Web"];

interface DeviceTypeFieldProps {
  label: string;
  value: string[];
  fullWidth?: boolean;
  onChange: (values: string[]) => void;
}

export const DeviceTypeField: FC<DeviceTypeFieldProps> = ({
  label,
  value,
  onChange,
}) => (
  <Autocomplete<string, true>
    multiple
    fullWidth
    options={DEVICE_TYPES}
    value={value}
    onChange={(_event, newValue) => onChange(newValue)}
    renderInput={(params) => <TextField {...params} label={label} />}
  />
);
